module.exports = __webpack_public_path__ + "static/heart-circle-bddc344f9e41cddd4e66a178075afb7e.svg";